/* tslint:disable */
/* eslint-disable */

import { ConcreteRequest } from "relay-runtime";
export type EditorUploadUrlQueryVariables = {
    extension: string;
    mime_type: string;
    suffix?: string | null;
};
export type EditorUploadUrlQueryResponse = {
    readonly uploadUrl: {
        readonly url: string;
        readonly thumbnails: {
            readonly large: string | null;
        };
    };
};
export type EditorUploadUrlQuery = {
    readonly response: EditorUploadUrlQueryResponse;
    readonly variables: EditorUploadUrlQueryVariables;
};



/*
query EditorUploadUrlQuery(
  $extension: String!
  $mime_type: String!
  $suffix: String
) {
  uploadUrl(extension: $extension, mime_type: $mime_type, suffix: $suffix) {
    url
    thumbnails {
      large
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "extension"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "mime_type"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "suffix"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "extension",
        "variableName": "extension"
      },
      {
        "kind": "Variable",
        "name": "mime_type",
        "variableName": "mime_type"
      },
      {
        "kind": "Variable",
        "name": "suffix",
        "variableName": "suffix"
      }
    ],
    "concreteType": "UploadUrl",
    "kind": "LinkedField",
    "name": "uploadUrl",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "url",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Thumbnail",
        "kind": "LinkedField",
        "name": "thumbnails",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "large",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EditorUploadUrlQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EditorUploadUrlQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "abc2df6a9e80d8a99db00a812e6fb929",
    "id": null,
    "metadata": {},
    "name": "EditorUploadUrlQuery",
    "operationKind": "query",
    "text": "query EditorUploadUrlQuery(\n  $extension: String!\n  $mime_type: String!\n  $suffix: String\n) {\n  uploadUrl(extension: $extension, mime_type: $mime_type, suffix: $suffix) {\n    url\n    thumbnails {\n      large\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = 'ac13f4675ebcd5909b300b5700759db0';
export default node;
